import React, { Component }     from 'react';
import { connect }              from 'react-redux';
import NotificationSystem       from 'react-notification-system';
import { SetStatusNotificacao,
         GetTipoMenuNotificacao } from  '../../../actions/notificacaoAction';

class Notificacao_Card extends Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.renderListNotificacaoCard =  this.renderListNotificacaoCard.bind(this);
    }   

    system() {
      return this.refs.notify;
    }
  
    addNotification(elem){

        const menu = this.props.GetTipoMenuNotificacao(elem.not_tip_id,this.props.menu);    

        this.system().addNotification({
            title       : elem.not_tip_nome,
            message     : elem.not_texto,
            level       : 'info',
            autoDismiss : 0,
            children: (
                <div>
{/*                 
                  <Link to={`${menu}`}>Anchor</Link> */}
                </div>
              )
        });
    }

    renderListNotificacaoCard(){

        if (this.props.notificacao.length > 0) {
            this.props.notificacao.map((elem,i)=>{
                if(elem.not_exibir>0) {
                    this.addNotification(elem);
                    this.props.SetStatusNotificacao(elem.not_id);
                }
            });
        }
    }

    render() {
   
        return (
                <div>
                  {
                    this.props.notificacao ? this.renderListNotificacaoCard() : ""
                   }
                  <NotificationSystem ref="notify" />
                </div>
              );
    }
}


function mapStateToProps(state){
    return {
        session     : state.auth.session,
        notificacao : state.notificacaoReducer.all_notificacao,
        menu        : state.configReducer.menu
    }
}

export default connect(mapStateToProps,{SetStatusNotificacao,GetTipoMenuNotificacao})(Notificacao_Card);



// WEBPACK FOOTER //
// ./src/components/aluno/notificacao/notificacao_card.js